//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamStupnuSchvaleniEpkDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-04-17                                                  </Created>
//  </FileHeader>



namespace Gordic.Adm.WebControls {

    /** interface - Rozšířené konfigurační parametry obsahující informace např. o databázi, konfiguraci zákazníka atd..  */
    export interface IGSeznamBaseExtensions {
        dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription
    }

    /**
     * Třída SeznamBase
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamBase extends GContentBase<IGSeznamBaseExtensions>  {

        /** element gridu */
        grid: JQuery<HTMLElement>;
        /** sloupce seznamu */
        gridSearchColumns: string[];
        /** formát sloupců gridu */
        gridFormat: Gordic.Data.GridFormat;
        /** element sidebaru */
        sidebar: JQuery<HTMLElement>;
        /** panel id (string) */
        panelId: string;
        /** element panelu v sidebaru */
        panelElement: JQuery<HTMLElement>;
        /** data na řádcích seznamu, pokud chceme vybrat jen aktuální řádek vybereme row[0], v případě více řádků je to poslední v poli row[n-1] */
        row: any[];
        /** element filtru */
        filter: JQuery<HTMLElement>;
        /** formulář pro přidávání políček filtru */
        filterForm: Gordic.Forms.Form;
        /** zda je content otev5en v tabu */ 
        isTab: boolean;

        /**
         * SeznamLicenceDesignerInit
         * 
         * @param {GContentType<SeznamBase>} that
         */
        static SeznamBaseInit(that: GContentType<SeznamBase>)
        {
            // Kontrola zda uživatel může přidávat
            that.actions.actNovy?.update({ enabled: Utils.getCanAddList(that.dataListDescription.data_right) })
            // zatím bez akce
        } 


        /** vytvořit formát seznamu - definice sloupců, napdpisů, šířek atd...  
         SPECIFIC
         */
        static createGridFormatBase(that: GContentType<SeznamBase>): Gordic.Data.GridFormat {

            var columnsDefinition = new Gordic.Data.GridFormat();

            return columnsDefinition;
        }

        /**
         * Funkce pro zjednodušené zjištění property
         * @param filterObj
         * @param name
         * @param property
         */
        static filterContains(filterObj: any, name: string, property: string = ""): any {
            if (property == "")
                property = name;
            if (filterObj[name] != undefined && filterObj[name] != null) {
                if (filterObj[name][property] != undefined && filterObj[name][property] != null)
                    return filterObj[name][property];
                else
                    return filterObj[name];
            }
            else
                return null;
        }

        /** dynamicky vytvořit stringu s GridSearchColumns na základě dataListDescription načteního ze serveru */
        //static createGridSearchColumnsByDataListDescription(that: GContentType<SeznamBase>, dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription): string[] {
        static createGridSearchColumnsByDataListDescription(that: GContentType<SeznamBase> ): string[] {            
            var gridSearchColumns = new Array();
            var sloupce = that.dataListDescription.list_fields || [];
            sloupce.forEach(function (item) {
                if (item.field_visible) {
                    gridSearchColumns.push(item.field_name);
                }
            });
            return gridSearchColumns;
        }

        /** dynamicky vytvořit formát seznamu na základě dataListDescription načteního ze serveru - definice sloupců, napdpisů, šířek atd... */
        //static createGridFormatByDataListDescription(that: GContentType<SeznamBase>, dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription): Gordic.Data.GridFormat {
        static createGridFormatByDataListDescription(that: GContentType<SeznamBase> ): Gordic.Data.GridFormat {

            var v_char_width = 8;
            var v_coll_add = 2;
            var v_char_caption_width = 9.3;
            var v_caption_add = 2;
            var v_sirka = 0;
            var v_sirka_nadpisu = 0;
            var v_maxCollChars = 50;
            var columnsDefinition = this.createGridFormatBase(that);

            var sloupce = that.dataListDescription.list_fields || [];
            var i = 0;
            sloupce.forEach(function (item) {
                if (i == 0 && item.field_name == "aktivita") {
                    columnsDefinition.addIconColumn({
                        name: item.field_name,
                        caption: item.field_caption || "",
                        iconTemplate: (row) => {
                            var text = "";
                            var icon = "";
                            switch (row.aktivita) {
                                case 100:
                                    text = "jres:33000139";
                                    icon = "fa-check-circle g-state-text g-state-success"
                                    break;
                                case 300:
                                    text = "jres:33000142"; //RC 33000142 : Připraven
                                    icon = "fa-exclamation-triangle g-state-text g-state-info";
                                    break;
                                case 500:
                                    text = "jres:33000140";
                                    icon = "fa-exclamation-triangle g-state-text g-state-warning";
                                    break;
                                case 600:
                                    text = "jres:33000141" //RC 33000141 : Návrh
                                    icon = "fa-exclamation-triangle g-state-text g-state-info";
                                    break;
                                default:
                                    text = "jres:33000143" //RC 33000143 : Zrušen
                                    icon = "fa-times-circle g-state-text g-state-error"
                                    break;
                            }
                            return { icon: icon, text: text, tooltip: text };
                        }
                    })
                } else {
                    if (item.field_visible) {
                        var field_base_type = item.field_base_type || "OTHER";    // as Gordic.General.GFieldBaseTypeEnum;
                        var v_caption = item.field_caption || "";
                        switch (field_base_type) {
                            //case "BOOLEAN":

                            //case Gordic.General.GFieldBaseTypeEnum.TEXT:
                            case "TEXT":
                                v_sirka = item.field_max_data_size || v_maxCollChars;
                                if (v_sirka > v_maxCollChars)
                                    v_sirka = v_maxCollChars;
                                if (v_sirka < 10)
                                    v_sirka = 10;
                                v_sirka = (v_sirka + v_coll_add) * v_char_width;
                                v_sirka_nadpisu = ((item.field_caption || "").length + v_caption_add) * v_char_caption_width;
                                if (v_sirka_nadpisu > v_sirka)
                                    v_sirka = v_sirka_nadpisu;

                                columnsDefinition.addTextColumn({
                                    name: item.field_name || "",
                                    caption: item.field_caption || "",
                                    width: v_sirka,
                                    fragment: ""
                                });
                                break;
                            case "DATETIME":
                                //var v_sirka = 16; JKlusacek - zmněna kvůli datumu - nebylo vidět celé
                                var v_sirka = 19;
                                v_sirka = v_sirka * v_char_width;
                                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                                if (v_sirka_nadpisu > v_sirka)
                                    v_sirka = v_sirka_nadpisu;

                                columnsDefinition.addDateTimeColumn({
                                    name: item.field_name || "",
                                    caption: item.field_caption || "",
                                    width: v_sirka,
                                    fragment: ""
                                });
                                break;
                            case "DATE":
                                var v_sirka = 6;
                                v_sirka = v_sirka * v_char_width;
                                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                                if (v_sirka_nadpisu > v_sirka)
                                    v_sirka = v_sirka_nadpisu;

                                columnsDefinition.addDateColumn({
                                    name: item.field_name || "",
                                    caption: item.field_caption || "",
                                    width: v_sirka,
                                    fragment: ""
                                });
                                break;
                            case "NUMBER":
                                var v_sirka = 7;
                                v_sirka = v_sirka * v_char_width;
                                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                                if (v_sirka_nadpisu > v_sirka)
                                    v_sirka = v_sirka_nadpisu;

                                columnsDefinition.addNumberColumn({
                                    name: item.field_name || "",
                                    caption: item.field_caption || "",
                                    width: v_sirka,
                                    fragment: ""
                                });
                                break;
                            case "DECIMAL":
                                var v_sirka = 15;
                                v_sirka = v_sirka * v_char_width;
                                v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                                if (v_sirka_nadpisu > v_sirka)
                                    v_sirka = v_sirka_nadpisu;

                                columnsDefinition.addDecimalColumn({
                                    name: item.field_name || "",
                                    caption: item.field_caption || "",
                                    width: item.field_size || 150,
                                    fragment: ""
                                });
                                break;
                        }
                        i++;
                    }
                }
            });

            return columnsDefinition;
        } // createGridFormat


        /** vytvořit formulář filtru - panel */
        static createFilterBase(that: GContentType<SeznamBase>, a_form: Forms.Form, a_autoLoad: boolean = false, apply_action: ((that, ev, ctx) => any) | null = null, filterOptions: Omit<IGFilterPanelOptions, "forms"> | null = null): JQuery<HTMLElement> {
            let v_filter = $("<div class='filter-adm-old' {0}>".format((that.isTab == true) ? "style='display:none'" : "")).appendTo(that.element)
                .gfilterpanel({
                    // 01.03.2021 - TFeik
                    // Nahrazení obsolete parametrů.
                    filterViewMode: (filterOptions != null) ? ((filterOptions.filterViewMode) ? filterOptions.filterViewMode : FilterViewMode.Simple) : FilterViewMode.Simple,
                    favorites: (filterOptions != null) ? ((filterOptions.favorites) ? filterOptions.favorites : null) : null,
                    hardDefaultFilter: (filterOptions != null) ? ((filterOptions.hardDefaultFilter) ? filterOptions.hardDefaultFilter : null) : null,
                    //simpleMode: true,
                    autoLoadAfterCreatePanel: a_autoLoad,  
                    favoriteLayoutDescriptor: "L3M2S1",
                    clearFilterButtonVisible: "NeverVisible",
                    forms: [a_form],
                    apply: (ev, ctx) => {
                        if (apply_action != null)
                            apply_action(that, ev, ctx)
                        setTimeout(() => {
                            $(".filter-adm-old").find(".gfilterpanel-DeleteButInFavorite").hide();
                        }, 100)
                    }
                });
            return (v_filter);
        }

        /** vytvořit formulář filtru - vytvoří tam filtrační políčka */
        static createFilterFormBase(that: GContentType<SeznamBase>): Forms.Form {

            var v_filterForm = new Gordic.Forms.Form({
                name: "FormFiltrGrid",
                tabLabel: "jres:32131044", //RC 32131044 : Kompletní filtr
                layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000"
            });

            return v_filterForm;
        }

        static createWarningNot(that: GContentType<SeznamBase>, settings: IGAdmMessageSettings) {
            that.notification("showToast", {
                title: settings.title,
                content: settings.text,
                icon: (settings.icon) ? settings.icon : "fa-exclamation-triangle",
                state: "warning",
                id: settings.id
            })
        }
    }
}
